import { useToast } from 'primevue/usetoast';
import { logger } from '@tools/logging';

const baseDurationPerCharacter = 75;
const minDuration = 3000;
const maxDuration = 10000;

export const useNotification = () => {
  try {
    const toast = useToast();

    const success = (message: string, indefinite = false) => {
      const calculatedDuration = message.length * baseDurationPerCharacter;
      const duration = Math.max(minDuration, Math.min(calculatedDuration, maxDuration));
      toast.add({ severity: 'success', detail: message, life: indefinite ? undefined : duration });
    };

    const error = (message: string) => {
      toast.add({ severity: 'error', detail: message });
    };

    const warning = (message: string) => {
      toast.add({ severity: 'warn', detail: message });
    };

    return {
      success,
      error,
      warning,
    };
  } catch (error) {
    // dit komt voor als de notification buiten een setup functie wordt gebruikt.
    logger.warn('Error initializing toast', error);
    return {
      success: (message: string) => console.error('Unsent success toast:', message),
      error: (message: string) => console.error('Unsent error toast:', message),
      warning: (message: string) => console.error('Unsent warning toast:', message),
    };
  }
};
